import styled from "styled-components";
import { theme } from "@themes";

export const ContentSelectInvite = styled.div`
  display: grid;
  grid-auto-rows: 0.5fr 1fr;
  grid-gap: 0.2em;
  ${(props) => (props.OnlyAssigned ? `z-index:3;` : ``)}
  ${(props) => (props.OnlyAssigned ? `background: white;` : ``)}
  border-radius: 9px;

  input {
    width: 100%;
    height: 30px;
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.primaryIconColor};
  }

  input::placeholder {
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.secondaryGrayDarkOne};
  }

  .css-1hb7zxy-IndicatorsContainer {
    div:nth-child(1) {
      display: ${(props) => (props.users ? "none" : "")};
    }
  }
  .css-xb97g8 {
    display: ${(props) => (props.users ? "none" : "")};
  }
`;

export const SelectStylesInvite = {
  control: (styles, { isFocused }) => ({
    ...styles,
  }),
  option: (styles, { data, isFocused }) => {
    return {
      ...styles,
    };
  },
  input: (styles, { isFocused }) => ({
    ...styles,
    margin: "0px",
  }),
};

export const ButtonLink = styled.a`
  opacity: ${(props) => (props.disabledSelector ? "0.5" : "1")};
  cursor: pointer;
  text-align: right;
  color: ${({ theme }) => theme.button.primary} !important;
  display: inline;
`;

export const List = styled.ul`
  padding-left: 1em;
  width: 345px;
  margin-top: -22px;
  margin-bottom: 0;
  ${(props) => props.OnlyAssigned && `z-index: 2;`}
  ${(props) => props.OnlyAssigned && `background: white;`}
  ${(props) => props.OnlyAssigned && `border-radius: 5px;`}
`;

export const TextTitleList = styled.p`
  color: ${({ theme }) => theme.neutral.gray[2600]};
  font-size: 14px;
`;
